// Action Types ( passed tense )
export const PASSWORD_ENTERED = 'SecurityAction.PASSWORD_ENTERED';



// WEBPACK FOOTER //
// ./src/actions/Security/types.js